module.exports = __webpack_public_path__ + "media/E1.831f5807.mp3";